import { openBlock as l, createElementBlock as a, normalizeClass as s, normalizeStyle as f, renderSlot as o } from "vue";
import { _ as d } from "../_plugin-vue_export-helper-dad06003.js";
const r = {
  name: "rRow",
  props: {
    /**
     * 栅格间隔
     */
    gutter: {
      type: Number,
      default: 0
    },
    /**
     * 是否启用flex布局
     */
    flexMode: {
      type: Boolean,
      default: !1
    },
    /**
     * flex 布局下的垂直对齐方式，可选值为top、middle、bottom
     */
    align: {
      type: String,
      default: ""
    },
    /**
     * flex 布局下的水平排列方式，可选值为start、end、center、space-around、space-between
     */
    justify: {
      type: String,
      default: ""
    }
  },
  computed: {
    styles() {
      const t = {};
      return this.gutter > 0 && (t.marginLeft = `-${this.gutter / 2}px`, t.marginRight = t.marginLeft), t;
    }
  }
};
function u(t, c, e, m, y, n) {
  return l(), a(
    "div",
    {
      class: s(["r-row", {
        "r-row-flex": e.flexMode,
        "is-justify-center": e.flexMode && e.justify === "center",
        "is-justify-end": e.flexMode && e.justify === "end",
        "is-justify-space-around": e.flexMode && e.justify === "space-around",
        "is-justify-space-between": e.flexMode && e.justify === "space-between",
        "is-align-middle": e.flexMode && e.align === "middle",
        "is-align-bottom": e.flexMode && e.align === "bottom"
      }]),
      style: f(n.styles)
    },
    [
      o(t.$slots, "default")
    ],
    6
    /* CLASS, STYLE */
  );
}
const i = /* @__PURE__ */ d(r, [["render", u], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/row/row.vue"]]);
i.install = function(t) {
  t.component(i.name, i);
};
export {
  i as default
};
